(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const calculators = document.querySelectorAll('.watts-calc');
    if (!calculators.length) return;

    calculators.forEach(container => {
      const calcType = container.dataset.calculatorType || 'watt';

      if (calcType === 'watt') {
        initWattCalculator(container);
      } else if (calcType === 'kw') {
        initKwCalculator(container);
      }
    });
  });

  function formatNumber(num, decimals = 4) {
    return parseFloat(num.toFixed(decimals)).toString();
  }

  function initWattCalculator(container) {
    let isWattsToVolts = true;

    const titleEl = container.querySelector('.js-watt-title');
    const changeBtn = container.querySelector('.js-watt-change-btn');
    const resetBtn = container.querySelector('.js-watt-reset-btn');
    const powerTypeRow = container.querySelector('.js-power-type-row');
    const inputRowWatts = container.querySelector('.js-input-row-watts');
    const inputRowVolts = container.querySelector('.js-input-row-volts');
    const inputRowPf = container.querySelector('.js-input-row-pf');
    const calcBtn = container.querySelector('.js-watt-calculate-btn');
    const resultEl = container.querySelector('.js-watt-result');
    const changeTextEl = container.querySelector('.js-watt-change-text');

    function renderMode() {
      if (isWattsToVolts) {
        titleEl.textContent = 'Watts to Volts';
        changeTextEl.textContent = 'Volts to Watts';
        inputRowWatts.classList.remove('hidden');
        inputRowVolts.classList.add('hidden');
        powerTypeRow.style.display = 'flex';
      } else {
        titleEl.textContent = 'Volts to Watts';
        changeTextEl.textContent = 'Watts to Volts';
        inputRowWatts.classList.add('hidden');
        inputRowVolts.classList.remove('hidden');
        powerTypeRow.style.display = 'flex';
      }
    }

    changeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      isWattsToVolts = !isWattsToVolts;
      renderMode();
    });

    resetBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const inputs = container.querySelectorAll('.field__input');
      inputs.forEach(input => input.value = '');
      resultEl.textContent = 'Enter the values above';
    });

    const powerTypeRadios = container.querySelectorAll('input[name="power-type"]');
    powerTypeRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        const powerType = this.value;
        if (powerType === 'dc') {
          inputRowPf.classList.add('hidden');
        } else {
          inputRowPf.classList.remove('hidden');
        }
      });
    });

    calcBtn.addEventListener('click', function () {
      let power, current, volts;
      let powerType = 'dc';
      let pf = 1;

      if (isWattsToVolts) {
        power = parseFloat(inputRowWatts.querySelector('.js-input-power').value);
        current = parseFloat(inputRowWatts.querySelector('.js-input-current').value);
        const radio = container.querySelector('input[name="power-type"]:checked');
        if (radio) powerType = radio.value;

        if (powerType !== 'dc') {
          pf = parseFloat(inputRowPf.querySelector('.js-input-pf').value) || 1;
          if (isNaN(pf) || pf < 0 || pf > 1) {
            resultEl.textContent = 'Power Factor must be between 0 and 1';
            return;
          }
        }

        if (isNaN(power) || isNaN(current) || current <= 0) {
          resultEl.textContent = 'Please enter valid Power (W) and Current (A)';
          return;
        }

        let result;
        if (powerType === 'dc') {
          result = power / current;
        } else if (powerType === 'ac') {
          result = power / (current * pf);
        } else if (powerType === 'ac3') {
          result = power / (Math.sqrt(3) * current * pf);
        }
        resultEl.textContent = ` ${formatNumber(result)} V`;
      } else {
        volts = parseFloat(inputRowVolts.querySelector('.js-input-volts').value);
        current = parseFloat(inputRowVolts.querySelector('.js-input-current').value);
        
        const radio = container.querySelector('input[name="power-type"]:checked');
        if (radio) powerType = radio.value;

        if (powerType !== 'dc') {
          pf = parseFloat(inputRowPf.querySelector('.js-input-pf').value) || 1;
          if (isNaN(pf) || pf < 0 || pf > 1) {
            resultEl.textContent = 'Power Factor must be between 0 and 1';
            return;
          }
        }

        if (isNaN(volts) || isNaN(current) || current <= 0) {
          resultEl.textContent = 'Please enter valid Volts (V) and Current (A)';
          return;
        }

        let result;
        if (powerType === 'dc') {
          result = volts * current;
        } else if (powerType === 'ac') {
          result = volts * current * pf;
        } else if (powerType === 'ac3') {
          result = volts * current * pf * Math.sqrt(3);
        }
        resultEl.textContent = ` ${formatNumber(result)} W`; 
      }
    });

    renderMode();
  }

  function initKwCalculator(container) {
    let mode = 'kWToKVA';

    const titleEl = container.querySelector('.js-kw-title');
    const changeBtn = container.querySelector('.js-kw-change-btn');
    const resetBtn = container.querySelector('.js-kw-reset-btn');
    const inputRowKw = container.querySelector('.js-kw');
    const inputRowKva = container.querySelector('.js-kva');
    const calcBtn = container.querySelector('.js-kw-calculate-btn');
    const resultEl = container.querySelector('.js-kw-result');
    const changeTextEl = container.querySelector('.js-kw-change-text');

    if (!titleEl || !changeBtn || !resetBtn || !calcBtn) return;

    function renderMode() {
      if (mode === 'kWToKVA') {
        titleEl.textContent = 'kW to kVA';
        changeTextEl.textContent = 'kVA to kW';
        inputRowKw.classList.remove('hidden');
        inputRowKva.classList.add('hidden');
      } else {
        titleEl.textContent = 'kVA to kW';
        changeTextEl.textContent = 'kW to kVA';
        inputRowKw.classList.add('hidden');
        inputRowKva.classList.remove('hidden');
      }
    }

    changeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('ok');
      mode = mode === 'kWToKVA' ? 'kVAToKW' : 'kWToKVA';
      renderMode();
    });

    resetBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const inputs = container.querySelectorAll('.field__input');
      inputs.forEach(input => input.value = '');
      resultEl.textContent = 'Enter the values above';
    });

    calcBtn.addEventListener('click', function () {
      let kw, kva, pf;
      if (mode === 'kWToKVA') {
        kw = parseFloat(inputRowKw.querySelector('.js-input-kw').value);
        pf = parseFloat(inputRowKw.querySelector('.js-input-pf').value);
      } else {
        kva = parseFloat(inputRowKva.querySelector('.js-input-kva').value);
        pf = parseFloat(inputRowKva.querySelector('.js-input-pf').value);
      }

      if (isNaN(pf) || pf <= 0 || pf > 1) {
        resultEl.textContent = 'Power Factor must be between 0 and 1';
        return;
      }

      let result;
      if (mode === 'kWToKVA') {
        if (isNaN(kw)) {
          resultEl.textContent = 'Please enter valid Power (kW)';
          return;
        }
        result = kw / pf;
        resultEl.textContent = ` ${formatNumber(result)} kVA`;
      } else {
        if (isNaN(kva)) {
          resultEl.textContent = 'Please enter valid Apparent Power (kVA)';
          return;
        }
        result = kva * pf;
        resultEl.textContent = ` ${formatNumber(result)} kW`;
      }
    });

    renderMode();
  }
})();